import LevelOne from "./LevelOne";

export default LevelOne;